<div>
  <div class="v4-layout-form v4-layout-form-vertical" [formGroup]="form">
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <ng-container *ngIf="detail?.review_type === 'review_guest'; else responseToGuest">
          <div [innerHTML]="'automation-edit_review_html_将评价' | translate: { guest: detail?.send_to }"></div>
          <!-- <span class="text-primary font-medium cursor-pointer">{{ detail?.send_to }}</span> will be reviewed at -->
        </ng-container>
        <ng-template #responseToGuest>
          <div [innerHTML]="'automation-edit_review_html_将回复' | translate: { guest: detail?.send_to }"></div>
          <!-- <span class="text-primary font-medium cursor-pointer">{{ detail?.send_to }}</span
          >’s review will be responded at -->
        </ng-template>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <div class="w-1/2 pr-2">
            <nz-date-picker
              formControlName="plan_date"
              class="w-full"
              nzSize="large"
              [nzFormat]="angularDateFormat"></nz-date-picker>
          </div>
          <div class="w-1/2 pl-2">
            <nz-time-picker
              formControlName="plan_time"
              class="w-full"
              nzSize="large"
              [nzFormat]="timeFormat"></nz-time-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "automation-edit_message_html_内容" | translate }}
        <!-- Content -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <textarea formControlName="content" nz-input rows="4"></textarea>
        </div>
        <div class="v4-layout-field-extra">
          <div class="w-[150px]">
            <host-quick-msg-picker (onSelect)="onSelectQuickMsg($event)"></host-quick-msg-picker>
          </div>
          <!-- <nz-select></nz-select> -->
        </div>
      </div>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between">
    <div>
      <a nz-button nzType="link" nzDanger (click)="onRemove()">
        {{ "automation-edit_message_html_移除" | translate }}
        <!-- Remove -->
      </a>
      <a class="ml-2" nz-button nzType="link" (click)="onClickEdit()">{{
        "automation-edit_message_html_编辑规则" | translate
      }}</a>
    </div>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onExecuteImmediately()">
        {{ "automation-edit_message_html_立即发送" | translate }}
        <!-- Send now -->
      </button>
      <button nz-button nzType="primary" nzSize="large" (click)="onSave()">
        {{ "word.save" | translate }}
        <!-- Save -->
      </button>
    </div>
  </div>
</div>
